/** 网络请求提示语
 * key:{SYSTEM_RESPONSE_MESSAGE}
 * @type {{SERVICE_NOT_IMPLEMENTED: string,
 * NO_ACCESS_RIGHTS: string,
 * CONNECTION_ERROR: string,
 * LOGIN_EXPIRE: string,
 * THE_HTTP_VERSION_IS_NOT_SUPPORTED: string,
 * THE_REQUEST_TIMEOUT: string,
 * SERVER_ERROR: string,
 * FAILED_TO_CONNECT_TO_SERVER: string,
 * NETWORK_ERROR: string,
 * SERVICE_UNAVAILABLE: string,
 * ACCESS_ERROR: string,
 * REQUEST_ERROR: string,
 * NETWORK_TIMEOUT: string}}
 */
export const SYSTEM_RESPONSE_MESSAGE = {
  REQUEST_ERROR: "400", // 请求错误(400)
  LOGIN_EXPIRE: "401", // 登录已过期(401)
  NO_ACCESS_RIGHTS: "403", // 无访问权限(403)
  ACCESS_ERROR: "404", // 请求出错(404)
  THE_REQUEST_TIMEOUT: "408", // 请求超时(408)
  SERVER_ERROR: "500", // 服务器错误(500)
  SERVICE_NOT_IMPLEMENTED: "501", // 服务未实现(501)
  NETWORK_ERROR: "502", // 网络错误(502)
  SERVICE_UNAVAILABLE: "503", // 服务不可用(503)
  NETWORK_TIMEOUT: "504", // 网络超时(504)
  THE_HTTP_VERSION_IS_NOT_SUPPORTED: "505", // HTTP版本不受支持(505)
  CONNECTION_ERROR: "error", // 连接出错 status 未知
  FAILED_TO_CONNECT_TO_SERVER: "error", // 连接服务器失败
};

export const ZETRIX_RESPONSE_MESSAGE = {
  SUCCESS: "Success",
  CANCEL: "Cancelled",
  FAIL: "Failure",
  CODE100001: "Missing parameter",
  CODE100002: "Unauthorized account",
  CODE100003: "Please switch your Zetrix Wallet account",
  CODE100004: "Please create a Zetrix Wallet account",
};
